import request from '@/util/request'


export const capaSearch = (data) => request.post('/api/capaList', data);  //CAPA请求搜索

export const capaRequestDetail = (data) => request.post('/api/capaDetail', data);  //CAPA请求详情


